module.exports = __webpack_public_path__ + "static/img/5232_phase_function_Paper_PointsHejduk_Prediction.a9661a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5232_phase_function_Paper_PointsHejduk_Prediction.png
// module id = lNaN
// module chunks = 0